import {
  SET_ACCOUNT,
  SET_ACCOUNT_LOADING,
  UPDATE_ROLE,
  CHANGE_EMAIL,
  CHANGE_AVATAR,
  CHANGE_NAME,
  MY_RT_IDENTITY,
  SET_NOTIFICATIONS,
  SET_PROVIDERS,
  UPGRADE_USER,
  UPDATE_ACCOUNT,
  UPDATE_GOOGLE_INTEGRATION,
  UPDATE_USER_SCHOOL,
  UPDATE_ONBOARDING,
  UPDATE_PROVIDERS,
  ADD_NOTIFICATION,
  MARK_NOTIFICATIONS_AS_READ,
} from 'store/mutation-types';
import Vue from 'vue';

export default {
  [SET_ACCOUNT](state, account) {
    Object.assign(state, account);
    return state;
  },
  [SET_ACCOUNT_LOADING](state, status) {
    state.loading = status;
  },
  [UPDATE_ACCOUNT](state, updatedKeys) {
    if (updatedKeys) {
      const updated_record = Object.assign(state, updatedKeys);
      Vue.set(state, 'currentRT', updated_record);
    }
    return state;
  },
  [UPDATE_GOOGLE_INTEGRATION](state, updatedKeys) {
    if (updatedKeys) {
      Vue.set(state, 'google_integration', updatedKeys);
    }
    return state;
  },
  [UPDATE_USER_SCHOOL](state, updatedKeys) {
    if (updatedKeys) {
      const updated_invite = Object.assign({}, state.school, updatedKeys);
      Vue.set(state, 'school', updated_invite);
    }
    return state;
  },
  [UPDATE_ROLE](state, role) {
    state.role = role;
  },
  [CHANGE_EMAIL](state, email) {
    state.email = email;
  },
  [CHANGE_AVATAR](state, avatar) {
    state.avatar_url = avatar;
  },
  [CHANGE_NAME](state, name) {
    state.name = name;
  },
  [MY_RT_IDENTITY](state, identity) {
    state.my_rt_user_details = identity;
  },
  [SET_NOTIFICATIONS](state, notifs) {
    state.notifications = notifs;
    return state;
  },
  [ADD_NOTIFICATION](state, notification) {
    if (state.notifications.length >= 20) {
      state.notifications.pop();
    }
    state.notifications.unshift(notification);
    return state;
  },
  [MARK_NOTIFICATIONS_AS_READ](state, notificationIDs) {
    state.notifications.forEach((n) => {
      if (notificationIDs.includes(n.id)) {
        n.seen = true;
      }
    });
    return state;
  },
  [UPGRADE_USER](state, user) {
    state.school_info = user.school_info;
    state.is_paid = user.is_paid;
    return state;
  },
  [UPDATE_ONBOARDING](state, onboardingObj) {
    state.onboarding = onboardingObj;
    return state;
  },
  ['ADD_ACTIVITY_PASSES'](state, number_of_passes) {
    state.activity_passes += number_of_passes;
    return state;
  },
  ['PUSHER_AUTHENTICATION'](state, socket_id) {
    state.socket_id = socket_id;
    return state;
  },
  [SET_PROVIDERS](state, providersArray) {
    Vue.set(state, 'providers', providersArray);
    state.providers = providersArray;
    return state;
  },
  [UPDATE_PROVIDERS](state, payload) {
    const { integration_id, connect } = payload;
    const provider_index = state.providers.findIndex(
      (p) => p.integration_id === integration_id
    );
    if (provider_index > -1) {
      const provider = state.providers[provider_index];
      provider.connected = connect ? true : false;
      Vue.set(state.providers, provider_index, provider);
    }
    return state;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/mutations.js